const dotenv = require('dotenv').config();
import Rollbar = require('rollbar');
import { BobBootstrapper } from './src/environment/bob-bootstrapper';
import { RollbarErrorReporter } from './src/infrastructure/trackers/rollbar-error-reporter';
import SpAnalyticsTracker from './src/infrastructure/trackers/sp-analytics-tracker';

const bootstrapper = new BobBootstrapper();

const rollbar = new Rollbar({
	accessToken: process.env.BOB_ROLLBAR_ACCESS_TOKEN as string,
	captureUncaught: true,
	captureUnhandledRejections: true,
	payload: {
		environment: 'dev'
	}
});

bootstrapper.setTracker(new SpAnalyticsTracker());
bootstrapper.setErrorReporter(new RollbarErrorReporter(rollbar));
bootstrapper.start();

